import React from "react"

import { useBlogRecentPosts } from "../../GraphQl/useRecentPosts"

import { BlogCard } from "../blog/blogCard"

export const RecentPosts = () => {
  const posts = useBlogRecentPosts()
  return (
    <div className="grid grid-cols-1 gap-10 md:grid-cols-3 lg:gap-16 py-16">
      {posts && posts.map(item => <BlogCard {...item} />)}
    </div>
  )
}
